module.exports = __webpack_public_path__ + "img/icon-chevron-left.a49ec3e9.svg";